<template>
    <div>
        <!-- Loader section -->
        <div class="preloader" style="display: none">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>

        <!-- maincss Headr Start Here -->
        <header class="main-header">
            <div
                v-if="!['DesignStudio', 'DesignStudioV3'].includes($route.name)"
                class="container"
            >
                <div class="top-nav-bar">
                    <div class="free-shipping-title">
                        TODAY ONLY!
                        <span class="text-uppercase">Free Shipping</span>,
                        <p>Free Rush, No Hidden Fees*</p>
                    </div>
                    <div class="shop-links">
                        <router-link
                            class="store-link company_store"
                            :to="{ name: 'company_store' }"
                        >
                            <img
                                src="/maincss/images/icons/store.svg"
                                class="links_icon"
                                alt="icon"
                            />
                            <span>COMPANY STORES</span>
                        </router-link>
                        <router-link
                            class="store-link team_store"
                            :to="{ name: 'team_store' }"
                        >
                            <img
                                src="/maincss/images/icons/team_stores.svg"
                                class="links_icon"
                                alt="icon"
                            />
                            <span>TEAM STORES</span>
                        </router-link>
                        <router-link
                            class="brand-link"
                            :to="{ path: `/product-list/tshirt24` }"
                        >
                            <img
                                src="/maincss/images/icons/hour-tshirts.png"
                                class="links_icon"
                                alt="icon"
                            />
                        </router-link>
                        <router-link
                            class="brand-link"
                            :to="{ name: 'fanraise' }"
                        >
                            <img
                                src="/maincss/images/icons/fan-faise.png"
                                class="links_icon"
                                alt="Fanraise"
                            />
                        </router-link>
                    </div>
                    <div class="header-top-links">
                        <h5>
                            <span
                                class="badge badge-warning font-weight-bold"
                                v-if="isAdminLoggedIn"
                                >Admin logged in as customer</span
                            >
                        </h5>
                        <a
                            class="btn btn_primary bg_primary_blue text_white"
                            href="javascript:void(0)"
                            v-if="isAdminLoggedIn"
                            @click="backToAdmin"
                        >
                            Back to the admin
                        </a>
                    </div>
                </div>
            </div>

            <nav
                class="navbar navbar-expand-lg bg_primary_blue main_top_header"
            >
                <div class="container">
                    <router-link class="navbar-brand" :to="{ path: '/' }">
                        <img
                            src="/maincss/images/logo.svg"
                            class="headerlogo"
                            alt="logo"
                        />
                    </router-link>

                    <div class="search-area">
                        <form
                            class="search-form-inline"
                            @submit.prevent="searchProducts"
                            data-vv-scope="search-form"
                        >
                            <input
                                class="search-form-control"
                                :class="
                                    errors.has('search-form.search')
                                        ? 'abc'
                                        : ''
                                "
                                type="search"
                                placeholder="Search"
                                aria-label="Search"
                                v-model.trim="filterOptions.searchKeyword"
                                name="search"
                                v-validate="'required'"
                                refs="searchKey"
                            />
                            <a
                                @click="
                                    filterOptions.searchKeyword = '';
                                    searchProducts();
                                "
                                class="search-btn search_close"
                            >
                                <img
                                    src="/maincss/images/cancel-blue.svg"
                                    class="headerlogo"
                                    alt="logo"
                                />
                            </a>
                            <button class="search-btn" type="submit">
                                <img
                                    src="/maincss/images/icons/magnifying-glass.svg"
                                    class="headerlogo"
                                    alt="logo"
                                />
                            </button>
                        </form>
                    </div>

                    <div class="common-links">
                        <a href="javascript:void(0)" class="search_button">
                            <img
                                src="/maincss/images/magnifying-glass.svg"
                                alt="icon"
                            />
                            <span>Search</span>
                        </a>
                        <!-- <a
                            href="#"
                            data-toggle="modal"
                            class="login-cart"
                            data-path="/edit-profile"
                            data-target="#login"
                            v-if="!isAuthenticatedClient"
                        >
                            <img
                                src="/maincss/images/icons/user.svg"
                                class="account_img_head"
                                alt="icon"
                            />
                            <span>Account</span>
                        </a>  -->
                        <a
                            href="javascript:void(0)"
                            class="acoount_fixed_icon_box_ty"
                            v-if="isAuthenticatedClient"
                        >
                            <router-link :to="{ name: 'EditProfile' }">
                                <img
                                    src="/maincss/images/icons/user.svg"
                                    alt="icon"
                                    class="account_img_head"
                                />
                                <span
                                    v-if="currentUserClient.first_name"
                                    :title="currentUserClient.first_name"
                                    >Welcome
                                    {{
                                        currentUserClient.first_name.length > 10
                                            ? currentUserClient.first_name.slice(
                                                  0,
                                                  10
                                              ) + "..."
                                            : currentUserClient.first_name
                                    }}</span
                                >
                            </router-link>
                        </a>

                        <router-link
                            :to="{ name: 'cartV3' }"
                            class="cart-count"
                            v-if="isAuthenticatedClient"
                        >
                            <img
                                src="/maincss/images/icons/cart.svg"
                                alt="icon"
                            />
                            <span class="cart-absolute">{{
                                cart_total_items
                            }}</span>
                            <span>Cart</span>
                        </router-link>
                    </div>
                </div>
            </nav>

            <div
                class="collapse navbar-collapse main_top_header"
                v-if="
                    ![
                        'DesignStudioNew',
                        'DesignStudio',
                        'business_credit_app'
                    ].includes($route.name)
                "
                id="navbarSupportedContent "
            >
                <div class="top-nav-bar d-none">
                    <div class="free-shipping-title">
                        <div class="d-inline-block free_ship">
                            TODAY ONLY! <span>Free Shipping</span>,
                            <p>Free Rush, No Hidden Fees*</p>
                        </div>
                        <div class="cross-img">
                            <img
                                src="/maincss/images/cancel.svg"
                                class="d-inline-block"
                            />
                        </div>
                    </div>

                    <div class="shop-links">
                        <router-link
                            class="store-link close_mobile_nav"
                            :to="{ name: 'company_store' }"
                        >
                            <img
                                src="/maincss/images/icons/store.svg"
                                class="links_icon"
                                alt="icon"
                            />
                            <span>COMPANY STORES</span>
                        </router-link>
                        <router-link
                            class="store-link close_mobile_nav"
                            :to="{ name: 'team_store' }"
                        >
                            <img
                                src="/maincss/images/icons/team_stores.svg"
                                class="links_icon"
                                alt="icon"
                            />
                            <span>TEAM STORES</span>
                        </router-link>
                        <router-link
                            class="brand-link close_mobile_nav"
                            :to="{ path: `/product-list/tshirt24` }"
                        >
                            <img
                                src="/maincss/images/icons/hour-tshirts.svg"
                                class="links_icon"
                                alt="icon"
                            />
                        </router-link>
                        <router-link
                            class="brand-link close_mobile_nav"
                            :to="{ name: 'fanraise' }"
                        >
                            <img
                                src="/maincss/images/icons/fan-faise.svg"
                                class="links_icon"
                                alt="Fanraise"
                            />
                        </router-link>
                    </div>
                </div>

                <div class="container">
                    <ul class="navbar-nav-menu mr-auto">
                        <li class="nav-item only_mobile_nav close_mobile_nav">
                            <router-link
                                class="nav-link"
                                :to="{ name: 'cartV3' }"
                                >Cart
                            </router-link>
                        </li>
                        <li class="nav-item only_mobile_nav close_mobile_nav">
                            <a
                                class="nav-link login-cart"
                                data-path="/MyAccount"
                                href="#"
                                data-toggle="modal"
                                data-target="#login"
                                v-if="!isAuthenticatedClient"
                            >
                                Account
                            </a>
                            <router-link
                                v-else
                                :to="{ name: 'Myorder' }"
                                class="nav-link"
                            >
                                Account
                            </router-link>
                        </li>

                        <li
                            class="nav-item close_mobile_nav mega-menu dropdown big-nav on-desktop_big_nav"
                            :class="{
                                'mega-menu-brands-li':
                                    mega_menu.slug === 'brands'
                            }"
                            @mouseenter="
                                onMegaMenuDesktopMouseEnter(mega_menu, $event)
                            "
                            @mouseleave="
                                scheduleMegaMenuDesktopLeave(mega_menu)
                            "
                            v-for="mega_menu in mega_menus"
                            :key="mega_menu.id"
                        >
                            <span
                                v-if="
                                    mega_menu.url == '' || mega_menu.url == '#'
                                "
                                class="navbar-nav-menu nav-link"
                                :class="
                                    $route.path.indexOf(
                                        '/product-list/apparel'
                                    ) !== -1
                                        ? 'router-link-exact-active'
                                        : ''
                                "
                            >
                                {{ mega_menu.name }}
                            </span>
                            <router-link
                                v-else
                                class="nav-link"
                                :to="{ path: mega_menu.url }"
                                :class="
                                    $route.path.indexOf(
                                        '/product-list/apparel'
                                    ) !== -1
                                        ? 'router-link-exact-active'
                                        : ''
                                "
                                >{{ mega_menu.name }}</router-link
                            >
                            <div
                                :class="{
                                    remove_arrow_icon:
                                        mega_menu.slug == 'brands'
                                }"
                                class="dropdown-menu"
                                aria-labelledby="navbarDropdown"
                                v-if="
                                    mega_menu.CmsMegaMenus &&
                                    mega_menu.CmsMegaMenus.length
                                "
                            >
                                <div
                                    class="bg-white bg-white-scroll"
                                    :class="{
                                        'd-flex': mega_menu.slug == 'brands',
                                        'mega-menu-brands-panel':
                                            mega_menu.slug == 'brands',
                                        nav_items: ulhover
                                    }"
                                >
                                    <ul
                                        class="dropdown_main_nav"
                                        @mouseenter="handleOver('main')"
                                        @mousemove="handleMove('main')"
                                        @mouseleave="handleOut('main')"
                                        v-for="(
                                            menuColumn, colIndex
                                        ) in getMenuColumns(mega_menu)"
                                        :key="`${mega_menu.slug}-col-${colIndex}`"
                                    >
                                        <li
                                            class="nav-item main_nav"
                                            @mouseover="
                                                showSubCat(
                                                    `${mega_menu.slug}-${category._menuIndex}`
                                                )
                                            "
                                            :class="
                                                isHoverTouch[
                                                    `${mega_menu.slug}-${category._menuIndex}`
                                                ]
                                                    ? 'active'
                                                    : ''
                                            "
                                            v-for="(
                                                category, _key
                                            ) in menuColumn"
                                            :key="`${mega_menu.slug}-${category.id}-${category._menuIndex}`"
                                        >
                                            <router-link
                                                class="dropdown-item"
                                                v-if="
                                                    !category.url.includes(
                                                        'http://'
                                                    ) &&
                                                    !category.url.includes(
                                                        'https://'
                                                    )
                                                "
                                                :to="{ path: category.url }"
                                                aria-haspopup="true"
                                            >
                                                {{
                                                    $filters.capitalize(
                                                        category.name
                                                    )
                                                }}
                                            </router-link>
                                            <a
                                                v-else
                                                :href="category.url"
                                                class="dropdown-item"
                                                aria-haspopup="true"
                                                >{{
                                                    $filters.capitalize(
                                                        category.name
                                                    )
                                                }}</a
                                            >
                                            <div
                                                v-if="
                                                    category.CmsMegaMenus &&
                                                    category.CmsMegaMenus.length
                                                "
                                                class="sub_menu row"
                                                :class="subhover"
                                                @mouseenter="handleOver('sub')"
                                                @mousemove="handleMove('sub')"
                                                @mouseleave="handleOut('sub')"
                                            >
                                                <div
                                                    class="col-md-5 mega-menu-main"
                                                >
                                                    <ul>
                                                        <li
                                                            v-for="attribute in category.CmsMegaMenus.filter(
                                                                (m, i) => i <= 9
                                                            )"
                                                            :key="`${attribute.item_type}-${attribute.id}`"
                                                        >
                                                            <router-link
                                                                class="dropdown-item"
                                                                :to="{
                                                                    path: attribute.url
                                                                }"
                                                                >{{
                                                                    attribute.name
                                                                }}</router-link
                                                            >
                                                        </li>
                                                    </ul>
                                                    <ul
                                                        v-if="
                                                            category.CmsMegaMenus.filter(
                                                                (m, i) => i > 9
                                                            ).length > 0
                                                        "
                                                    >
                                                        <li
                                                            v-for="attribute in category.CmsMegaMenus.filter(
                                                                (m, i) => i > 9
                                                            )"
                                                            :key="`${attribute.item_type}-${attribute.id}`"
                                                        >
                                                            <router-link
                                                                class="dropdown-item"
                                                                :to="{
                                                                    path: attribute.url
                                                                }"
                                                                >{{
                                                                    attribute.name
                                                                }}</router-link
                                                            >
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    v-if="shouldShowMegaMenuMore(mega_menu)"
                                    class="mega-menu-show-more-bar mega-menu-show-more-bar--desktop-only"
                                >
                                    <router-link
                                        v-if="
                                            !isExternalMegaMenuUrl(
                                                getMegaMenuShowMorePath(
                                                    mega_menu
                                                )
                                            )
                                        "
                                        class="mega-menu-show-more-link"
                                        :to="{
                                            path: getMegaMenuShowMorePath(
                                                mega_menu
                                            )
                                        }"
                                    >
                                        Show More
                                    </router-link>
                                    <a
                                        v-else
                                        class="mega-menu-show-more-link"
                                        :href="
                                            getMegaMenuShowMorePath(mega_menu)
                                        "
                                        rel="noopener noreferrer"
                                    >
                                        Show More
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li
                            class="nav-item mega-menu dropdown big-nav on-mobile_big-nav"
                            @click="openNav(`mySidenav-${mega_menu.id}`)"
                            v-for="mega_menu in mega_menus"
                            :key="`${mega_menu.id}-1`"
                        >
                            <a
                                class="nav-link"
                                href="javascript:void(0)"
                                :class="
                                    $route.path.indexOf(
                                        '/product-list/apparel'
                                    ) !== -1 || productTypeName == 'Apparel'
                                        ? 'router-link-exact-active'
                                        : ''
                                "
                            >
                                {{ mega_menu.name }}
                            </a>

                            <div
                                :id="`mySidenav-${mega_menu.id}`"
                                class="sidenav"
                                v-if="
                                    mega_menu.CmsMegaMenus &&
                                    mega_menu.CmsMegaMenus.length
                                "
                            >
                                <div
                                    class="d-flex justify-content-between flex-wrap close-myside-nav px_14"
                                    :data-parent="`#mySidenav-${mega_menu.id}`"
                                >
                                    <a
                                        href="#navbarSupportedContent"
                                        class="startbtn p-0"
                                    >
                                        <img
                                            src="/maincss/images/side_bar_category_arrow.svg"
                                            alt=" "
                                            class="ml-auto"
                                        />
                                    </a>
                                    <a
                                        href="javascript:void(0)"
                                        class="closebtn"
                                        ><img src="/maincss/images/cancel.svg"
                                    /></a>
                                </div>
                                <div>
                                    <ul class="dropdown_main_nav">
                                        <li
                                            class="nav-item main_nav"
                                            @click="
                                                oopenNav(
                                                    `childnav-${mega_menu.id}` +
                                                        key
                                                )
                                            "
                                            v-for="(
                                                category, key
                                            ) in mega_menu.CmsMegaMenus"
                                            :key="`${mega_menu.slug}-child${category.id}`"
                                        >
                                            <a
                                                class="dropdown-item"
                                                :href="category.url"
                                                aria-haspopup="true"
                                            >
                                                {{
                                                    $filters.capitalize(
                                                        category.name
                                                    )
                                                }}
                                            </a>
                                            <div
                                                v-if="
                                                    category.CmsMegaMenus &&
                                                    category.CmsMegaMenus.length
                                                "
                                                :id="
                                                    `childnav-${mega_menu.id}` +
                                                    key
                                                "
                                                class="sidenav sub_sub_menu"
                                            >
                                                <div
                                                    class="d-flex justify-content-between flex-wrap close-myside-nav px_14"
                                                    :data-parent="
                                                        `#childnav-1${mega_menu.id}` +
                                                        key
                                                    "
                                                >
                                                    <a
                                                        href="#mySidenav"
                                                        class="startbtn p-0"
                                                    >
                                                        <img
                                                            src="/maincss/images/side_bar_category_arrow.svg"
                                                            alt=" "
                                                            class="ml-auto"
                                                        />
                                                    </a>
                                                    <a
                                                        href="javascript:void(0)"
                                                        class="closebtn"
                                                        ><img
                                                            src="/maincss/images/cancel.svg"
                                                    /></a>
                                                </div>

                                                <ul class="dropdown_main_nav">
                                                    <li
                                                        v-for="attribute in category.CmsMegaMenus"
                                                        :key="`${attribute.item_type}-${attribute.id}`"
                                                    >
                                                        <router-link
                                                            class="dropdown-item close_mobile_nav"
                                                            :to="{
                                                                path: attribute.url
                                                            }"
                                                        >
                                                            {{ attribute.name }}
                                                        </router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li class="nav-item close_mobile_nav">
                            <a
                                href="#"
                                data-toggle="modal"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue"
                                data-path="/design-studio/v3"
                                data-target="#design-studio"
                                v-if="designFlag == false"
                            >
                                <span>Design Studio</span>
                            </a>
                            <a href="javascript:void(0)" v-else>
                                <router-link
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header"
                                    :to="{ name: 'DesignStudioV3' }"
                                >
                                    Design Studio
                                </router-link>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <button class="navbar-toggler menu">
                <input
                    v-model="mobile_nav_bar"
                    type="checkbox"
                    id="mobile_nav_bar"
                    onchange="navbar_toggler(this)"
                />
                <div></div>
                <div></div>
                <div></div>
            </button>

            <!-- navbar_fixed_header_custom start -->
            <div class="navbar_fixed_header_custom">
                <nav class="navbar navbar-expand-lg bg_primary_blue">
                    <div class="container">
                        <router-link class="navbar-brand" :to="{ path: '/' }">
                            <img
                                src="/maincss/images/logo.svg"
                                class="headerlogo"
                                alt="logo"
                            />
                        </router-link>
                        <div class="navbar_fixed_custom_ul">
                            <ul class="navbar-nav-menu mr-auto">
                                <li
                                    class="nav-item close_mobile_nav mega-menu dropdown big-nav on-desktop_big_nav"
                                    @mouseenter="
                                        onMegaMenuDesktopMouseEnter(
                                            mega_menu,
                                            $event
                                        )
                                    "
                                    @mouseleave="
                                        clearSubCat();
                                        onMegaMenuDesktopLeave(mega_menu);
                                    "
                                    v-for="mega_menu in mega_menus"
                                    :key="`${mega_menu.id}-2`"
                                >
                                    <router-link
                                        class="nav-link"
                                        :to="{ path: mega_menu.url }"
                                        :class="
                                            $route.path.indexOf(
                                                '/product-list/' +
                                                    mega_menu.slug
                                            ) !== -1
                                                ? 'router-link-exact-active'
                                                : ''
                                        "
                                    >
                                        {{ mega_menu.name }}
                                    </router-link>
                                    <div
                                        :class="{
                                            remove_arrow_icon:
                                                mega_menu.slug == 'brands'
                                        }"
                                        @mouseenter="handleOver('main')"
                                        @mousemove="handleMove('main')"
                                        @mouseleave="handleOut('main')"
                                        class="dropdown-menu"
                                        aria-labelledby="navbarDropdown"
                                        v-if="
                                            mega_menu.CmsMegaMenus &&
                                            mega_menu.CmsMegaMenus.length
                                        "
                                    >
                                        <div
                                            class="bg-white bg-white-scroll"
                                            :class="{
                                                'd-flex':
                                                    mega_menu.slug == 'brands',
                                                'mega-menu-brands-panel':
                                                    mega_menu.slug == 'brands',
                                                nav_items: ulhover
                                            }"
                                        >
                                            <ul
                                                class="dropdown_main_nav"
                                                @mouseenter="handleOver('main')"
                                                @mousemove="handleMove('main')"
                                                @mouseleave="handleOut('main')"
                                                v-for="(
                                                    menuColumn, colIndex
                                                ) in getMenuColumns(mega_menu)"
                                                :key="`${mega_menu.slug}-fixed-col-${colIndex}`"
                                            >
                                                <li
                                                    class="nav-item main_nav"
                                                    @mouseover="
                                                        showSubCat(
                                                            `${mega_menu.slug}-${category._menuIndex}`
                                                        )
                                                    "
                                                    :class="
                                                        isHoverTouch[
                                                            `${mega_menu.slug}-${category._menuIndex}`
                                                        ]
                                                            ? 'active'
                                                            : ''
                                                    "
                                                    v-for="(
                                                        category, _key
                                                    ) in menuColumn"
                                                    :key="`${mega_menu.slug}-${category.id}-${category._menuIndex}`"
                                                >
                                                    <router-link
                                                        class="dropdown-item"
                                                        v-if="
                                                            !category.url.includes(
                                                                'http://'
                                                            ) &&
                                                            !category.url.includes(
                                                                'https://'
                                                            )
                                                        "
                                                        :to="{
                                                            path: category.url
                                                        }"
                                                        aria-haspopup="true"
                                                    >
                                                        {{
                                                            $filters.capitalize(
                                                                category.name
                                                            )
                                                        }}
                                                    </router-link>
                                                    <a
                                                        v-else
                                                        :href="category.url"
                                                        class="dropdown-item"
                                                        aria-haspopup="true"
                                                        >{{
                                                            $filters.capitalize(
                                                                category.name
                                                            )
                                                        }}</a
                                                    >
                                                    <div
                                                        v-if="
                                                            category.CmsMegaMenus &&
                                                            category
                                                                .CmsMegaMenus
                                                                .length
                                                        "
                                                        class="sub_menu row"
                                                        :class="subhover"
                                                        @mouseenter="
                                                            handleOver('sub')
                                                        "
                                                        @mousemove="
                                                            handleMove('sub')
                                                        "
                                                        @mouseleave="
                                                            handleOut('sub')
                                                        "
                                                    >
                                                        <div class="col-md-5">
                                                            <ul>
                                                                <li
                                                                    v-for="attribute in category.CmsMegaMenus.filter(
                                                                        (
                                                                            m,
                                                                            i
                                                                        ) =>
                                                                            i <=
                                                                            9
                                                                    )"
                                                                    :key="`${attribute.item_type}-${attribute.id}`"
                                                                >
                                                                    <router-link
                                                                        class="dropdown-item"
                                                                        :to="{
                                                                            path: attribute.url
                                                                        }"
                                                                    >
                                                                        {{
                                                                            attribute.name
                                                                        }}
                                                                    </router-link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <ul>
                                                                <li
                                                                    v-for="attribute in category.CmsMegaMenus.filter(
                                                                        (
                                                                            m,
                                                                            i
                                                                        ) =>
                                                                            i >
                                                                            9
                                                                    )"
                                                                    :key="`${attribute.item_type}-${attribute.id}`"
                                                                >
                                                                    <router-link
                                                                        class="dropdown-item"
                                                                        :to="{
                                                                            path: attribute.url
                                                                        }"
                                                                    >
                                                                        {{
                                                                            attribute.name
                                                                        }}
                                                                    </router-link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            v-if="
                                                shouldShowMegaMenuMore(
                                                    mega_menu
                                                )
                                            "
                                            class="mega-menu-show-more-bar mega-menu-show-more-bar--desktop-only"
                                        >
                                            <router-link
                                                v-if="
                                                    !isExternalMegaMenuUrl(
                                                        getMegaMenuShowMorePath(
                                                            mega_menu
                                                        )
                                                    )
                                                "
                                                class="mega-menu-show-more-link"
                                                :to="{
                                                    path: getMegaMenuShowMorePath(
                                                        mega_menu
                                                    )
                                                }"
                                            >
                                                Show More
                                            </router-link>
                                            <a
                                                v-else
                                                class="mega-menu-show-more-link"
                                                :href="
                                                    getMegaMenuShowMorePath(
                                                        mega_menu
                                                    )
                                                "
                                                rel="noopener noreferrer"
                                            >
                                                Show More
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li
                                    class="nav-item mega-menu dropdown big-nav on-mobile_big-nav"
                                    @click="
                                        openNav(`mySidenav-${mega_menu.id}`)
                                    "
                                    v-for="mega_menu in mega_menus"
                                    :key="mega_menu.id"
                                >
                                    <a
                                        class="nav-link"
                                        href="javascript:void(0)"
                                        :class="
                                            $route.path.indexOf(
                                                '/product-list/apparel'
                                            ) !== -1
                                                ? 'router-link-exact-active'
                                                : ''
                                        "
                                    >
                                        {{ mega_menu.name }}
                                    </a>

                                    <div
                                        :id="`mySidenav-${mega_menu.id}`"
                                        class="sidenav"
                                    >
                                        <div
                                            class="d-flex justify-content-between flex-wrap close-myside-nav px_14"
                                            :data-parent="`#mySidenav-${mega_menu.id}`"
                                        >
                                            <a
                                                href="#navbarSupportedContent"
                                                class="startbtn p-0"
                                            >
                                                <img
                                                    src="/maincss/images/side_bar_category_arrow.svg"
                                                    alt=" "
                                                    class="ml-auto"
                                                />
                                            </a>
                                            <a
                                                href="javascript:void(0)"
                                                class="closebtn"
                                                ><img
                                                    src="/maincss/images/cancel.svg"
                                            /></a>
                                        </div>
                                        <div>
                                            <ul class="dropdown_main_nav">
                                                <li
                                                    class="nav-item main_nav"
                                                    @click="
                                                        oopenNav(
                                                            `childnav-${mega_menu.id}` +
                                                                key
                                                        )
                                                    "
                                                    v-for="(
                                                        category, key
                                                    ) in mega_menu.CmsMegaMenus"
                                                    :key="
                                                        `${mega_menu.slug}-child` +
                                                        category.id
                                                    "
                                                >
                                                    <a
                                                        class="dropdown-item"
                                                        :href="'javascript:void(0)'"
                                                        aria-haspopup="true"
                                                    >
                                                        {{
                                                            $filters.capitalize(
                                                                category.name
                                                            )
                                                        }}
                                                    </a>
                                                    <div
                                                        :id="
                                                            `childnav-${mega_menu.id}` +
                                                            key
                                                        "
                                                        class="sidenav sub_sub_menu"
                                                    >
                                                        <div
                                                            class="d-flex justify-content-between flex-wrap close-myside-nav px_14"
                                                            :data-parent="
                                                                `#childnav-${mega_menu.id}` +
                                                                key
                                                            "
                                                        >
                                                            <a
                                                                href="#mySidenav"
                                                                class="startbtn p-0"
                                                            >
                                                                <img
                                                                    src="/maincss/images/side_bar_category_arrow.svg"
                                                                    alt=" "
                                                                    class="ml-auto"
                                                                />
                                                            </a>
                                                            <a
                                                                href="javascript:void(0)"
                                                                class="closebtn"
                                                                ><img
                                                                    src="/maincss/images/cancel.svg"
                                                            /></a>
                                                        </div>

                                                        <ul
                                                            class="dropdown_main_nav"
                                                        >
                                                            <li
                                                                v-for="attribute in category.CmsMegaMenus"
                                                                :key="
                                                                    `${attribute.type}-` +
                                                                    attribute.id
                                                                "
                                                            >
                                                                <router-link
                                                                    class="dropdown-item close_mobile_nav"
                                                                    :to="{
                                                                        path: attribute.url
                                                                    }"
                                                                >
                                                                    {{
                                                                        attribute.name
                                                                    }}
                                                                </router-link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>

                                <li class="nav-item close_mobile_nav">
                                    <a
                                        href="#"
                                        data-toggle="modal"
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue"
                                        data-path="/design-studio"
                                        data-target="#design-studio"
                                        v-if="designFlag == false"
                                    >
                                        <span>Design Studio</span>
                                    </a>
                                    <a href="javascript:void(0)" v-else>
                                        <router-link
                                            class="design_studio_fix_header_btn btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header"
                                            :to="{ name: 'DesignStudioV3' }"
                                        >
                                            Design Studio
                                        </router-link>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="search-area">
                            <form
                                @submit.prevent="searchProducts"
                                data-vv-scope="search-form"
                                class="search-form-inline"
                            >
                                <input
                                    type="search"
                                    :class="
                                        errors.has('search-form.search')
                                            ? 'abc'
                                            : ''
                                    "
                                    placeholder="Search"
                                    aria-label="Search"
                                    name="search"
                                    refs="searchKey"
                                    class="search-form-control"
                                    v-model.trim="filterOptions.searchKeyword"
                                    v-validate="'required'"
                                    aria-required="true"
                                    aria-invalid="false"
                                />
                                <button type="submit" class="search-btn">
                                    <img
                                        src="/maincss/images/icons/magnifying-glass.svg"
                                        alt="logo"
                                        class="headerlogo"
                                    /></button
                                ><a
                                    @click="
                                        filterOptions.searchKeyword = '';
                                        searchProducts();
                                    "
                                    class="search-btn search_close"
                                    ><img
                                        src="/maincss/images/cancel-blue.svg"
                                        alt="logo"
                                        class="headerlogo"
                                /></a>
                            </form>
                        </div>
                        <div class="common-links fixed_custom_common">
                            <a href="javascript:void(0)" class="search_button">
                                <img
                                    src="/maincss/images/magnifying-glass.svg"
                                    alt="icon"
                                />
                                <span>Search</span>
                            </a>
                            <!--  <a
                                v-if="!isAuthenticatedClient"
                                href="javascript:;"
                                data-toggle="modal"
                                class="login-cart"
                                data-path="/myorder"
                                data-target="#login"
                            >
                                <img
                                    src="/maincss/images/icons/user.svg"
                                    class="account_img_head"
                                    alt="icon"
                                />
                            </a> -->
                            <router-link
                                v-if="isAuthenticatedClient"
                                :to="{ name: 'Myorder' }"
                            >
                                <img
                                    src="/maincss/images/icons/user.svg"
                                    alt="icon"
                                    class="account_img_head"
                                />
                            </router-link>

                            <router-link
                                v-if="isAuthenticatedClient"
                                :to="{ name: 'cartV3' }"
                                class="cart-count"
                            >
                                <img
                                    src="/maincss/images/icons/cart.svg"
                                    alt="icon"
                                />
                                <span class="cart-absolute">
                                    {{ cart_total_items }}
                                </span>
                            </router-link>
                        </div>
                    </div>
                </nav>
            </div>
            <!-- navbar_fixed_header_custom end -->
        </header>
        <!-- maincss Headr End Here -->

        <!--Forgot password-->
        <ForgotPasswordModal />
        <!-- maincss Register Modal -->
        <RegisterModal />
        <LoginModal />
        <DesignStudioModal />
        <SaveDesignModal />
        <PrivacyPolicyModal />
        <TermsConditionsModal />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
    LOGOUT,
    FETCH_ALL_DECORATION_TEMPLATES,
    UPDATE_ADMIN_LOGGED_STATUS
} from "@/store/actions.type";
import ApiService from "@/common/api.service";
import LoginModal from "@/components/frontend/LoginModal";
import RegisterModal from "@/components/accounts/RegisterModal";
import ForgotPasswordModal from "@/components/accounts/ForgotPasswordModal";
import DesignStudioModal from "@/components/frontend/DesignStudioModal";
import SaveDesignModal from "@/components/frontend/SaveDesignModal";
import PrivacyPolicyModal from "@/components/frontend/PrivacyPolicyModal";
import TermsConditionsModal from "@/components/frontend/TermsConditionsModal";
import { ADMIN_BASE_URL } from "@/common/config";

export default {
    name: "RwvHeader",
    components: {
        LoginModal,
        RegisterModal,
        ForgotPasswordModal,
        DesignStudioModal,
        SaveDesignModal,
        PrivacyPolicyModal,
        TermsConditionsModal
    },
    data() {
        return {
            sitekey: "6LeO510lAAAAAEo-dFZ50cbrWaS4gRPnEqFi-_X3", // OLD KEY: 6Ld8A1IgAAAAAC5RTdjFW82Y_RYAbVrNVltIaoLe
            recaptcha: null,
            captchaErrMsg: true,
            productTypeName: "",
            productTypePath: "/",
            subhover: "",
            isHoverTouch: {},
            sleeve_list: [],
            style_category_list: [],
            fabric_list: [],
            category_list: [],
            attribute_list: [],
            cart_total_items: 0,
            grand_total: 0,
            mobile_nav_bar: false,
            login_data: [
                {
                    email: null,
                    password: null
                }
            ],
            registration_data: [
                {
                    first_name: null,
                    last_name: null,
                    email: null,
                    password: null,
                    confirm_password: null,
                    accept_terms: null
                }
            ],
            resetform_data: {
                email: null
            },
            filterOptions: {
                searchKeyword: ""
            },
            ulhover: "",
            designFlag: localStorage.getItem("design") ? true : false,
            mega_menus: [],
            admin_base_url: ADMIN_BASE_URL,
            /** 768px–1300px: measure dropdown + Show More on overflow; >1300px show full list; <768 mobile nav */
            megaMenuShowMoreBreakpointActive:
                typeof window !== "undefined" &&
                window.matchMedia &&
                window.matchMedia("(min-width: 768px) and (max-width: 1300px)")
                    .matches,
            /** mega_menu.id -> undefined = not measured yet; null = all items fit; number = max top-level items to show */
            megaMenuDisplayLimits: {},
            megaMenuOverflowRunId: 0,
            megaMenuMql: null,
            megaMenuMqlHandler: null,
            /** Brands fixed dropdown: delayed leave so cursor can cross the gap without closing */
            megaMenuBrandsLeaveTimer: null,
            /** >=1300px: show all Brands in mega menu; <1300: cap 50 + Show More */
            megaMenuBrandsWideDesktop:
                typeof window !== "undefined" &&
                window.matchMedia &&
                window.matchMedia("(min-width: 1300px)").matches,
            megaMenuBrandsWideMql: null,
            megaMenuBrandsWideMqlHandler: null
        };
    },
    computed: {
        ...mapGetters([
            "currentUserClient",
            "isAuthenticatedClient",
            "printTemplates",
            "embroideryTemplates",
            "isAdminLoggedIn"
        ])
    },

    watch: {
        $route(to, _from) {
            if (to.name != "search") {
                this.filterOptions.searchKeyword = "";
            }
            // console.log(_from);
        },
        currentUserClient(newVal, oldVal) {
            if (newVal.id && (!oldVal.id || newVal.id !== oldVal.id)) {
                // User has just logged in, call getCart
                this.getCart();
            }
        }
    },
    beforeMount() {
        this.$store.dispatch(FETCH_ALL_DECORATION_TEMPLATES);
    },

    mounted() {
        this.$store.dispatch(UPDATE_ADMIN_LOGGED_STATUS);
        var _this = this;

        /*  setTimeout(() => {
            _this.getCart();
        }, 1000); */

        //alert(JSON.stringify(_this.currentUserClient))
        if (!_this.currentUserClient.id) {
            if (localStorage.getItem("cart")) {
                _this.cart_items = JSON.parse(localStorage.getItem("cart"));
            } else {
                _this.cart_items = [];
            }
        }
        // modal popup scroll
        /* eslint-disable */
        $(".modal").on("hide.bs.modal", function () {
            $("body").css("overflow", "auto");
        });
        $(".modal").on("show.bs.modal", function () {
            $("body").css("overflow", "hidden");
        });

        $(document).on("click", ".close-myside-nav", function () {
            let parent_element = $(this).data("parent");
            $(parent_element).attr("style", "");
        });
        $(document).on("click", "#mobile_nav_bar", function () {
            $(".close-myside-nav").each(function () {
                let parent_element = $(this).data("parent");
                $(parent_element).attr("style", "");
            });
        });

        $(document).on("click", ".close_mobile_nav", function () {
            $("#mobile_nav_bar").prop("checked", false);
            navbar_toggler($("#mobile_nav_bar"));
            _this.mobile_nav_bar = _this.mobile_nav_bar ? false : true;
        });
        $(document).on("hide.bs.modal", "#register", function () {
            _this.$validator.reset();
            _this.registration_data = [
                {
                    first_name: null,
                    last_name: null,
                    email: null,
                    password: null,
                    confirm_password: null,
                    accept_terms: null
                }
            ];
        });
        $(document).on("hide.bs.modal", "#forgotpassword", function () {
            _this.$validator.reset();
            _this.resetform_data = {
                email: null
            };
        });
        _this.$bus.on("update-cart", (data) => {
            setTimeout(() => {
                _this.getCart();
            }, 500);
        });
        /* eslint-enable */
        _this.getMegaMenus();

        if (typeof window !== "undefined" && window.matchMedia) {
            _this.megaMenuMql = window.matchMedia(
                "(min-width: 768px) and (max-width: 1300px)"
            );
            _this.megaMenuShowMoreBreakpointActive = _this.megaMenuMql.matches;
            _this.megaMenuMqlHandler = function (e) {
                _this.megaMenuShowMoreBreakpointActive = e.matches;
                if (!e.matches) {
                    _this.megaMenuDisplayLimits = {};
                    _this.megaMenuOverflowRunId++;
                }
            };
            if (_this.megaMenuMql.addEventListener) {
                _this.megaMenuMql.addEventListener(
                    "change",
                    _this.megaMenuMqlHandler
                );
            } else if (_this.megaMenuMql.addListener) {
                _this.megaMenuMql.addListener(_this.megaMenuMqlHandler);
            }

            _this.megaMenuBrandsWideMql = window.matchMedia(
                "(min-width: 1300px)"
            );
            _this.megaMenuBrandsWideDesktop =
                _this.megaMenuBrandsWideMql.matches;
            _this.megaMenuBrandsWideMqlHandler = function (e) {
                _this.megaMenuBrandsWideDesktop = e.matches;
            };
            if (_this.megaMenuBrandsWideMql.addEventListener) {
                _this.megaMenuBrandsWideMql.addEventListener(
                    "change",
                    _this.megaMenuBrandsWideMqlHandler
                );
            } else if (_this.megaMenuBrandsWideMql.addListener) {
                _this.megaMenuBrandsWideMql.addListener(
                    _this.megaMenuBrandsWideMqlHandler
                );
            }
        }
    },
    beforeUnmount() {
        if (
            typeof window !== "undefined" &&
            this._brandsMegaMenuResizeHandler
        ) {
            window.removeEventListener(
                "resize",
                this._brandsMegaMenuResizeHandler
            );
        }
        if (this.megaMenuMql && this.megaMenuMqlHandler) {
            if (this.megaMenuMql.removeEventListener) {
                this.megaMenuMql.removeEventListener(
                    "change",
                    this.megaMenuMqlHandler
                );
            } else if (this.megaMenuMql.removeListener) {
                this.megaMenuMql.removeListener(this.megaMenuMqlHandler);
            }
        }
        this.cancelMegaMenuBrandsLeaveTimer();
    },
    methods: {
        verifyCaptcha(response) {
            this.recaptcha = response;
            if (this.recaptcha) {
                this.captchaErrMsg = false;
            }
        },
        validate() {
            // if validate true exec recaptcha
            // this.$refs.recaptcha.execute()
        },
        closePopup() {
            document.getElementById("register-popup-close").click();
        },
        hasrecord(style, fabric, sleevs, genderage) {
            const total =
                style.length + fabric.length + sleevs.length + genderage.length;
            return total > 0;
        },
        handleOver(handleon) {
            if (handleon == "sub") {
                this.subhover = "sub-hover";
                this.ulhover = "";
            } else {
                this.ulhover = "hover";
            }
        },
        handleMove(handleon) {
            if (handleon == "sub") {
                this.subhover = "sub-hover";
            }
        },
        handleOut(handleon) {
            if (handleon == "sub") {
                this.subhover = "";
                this.ulhover = "hover";
            } else {
                this.ulhover = "";
            }
        },
        getAttributes() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/attributes")
                    .then(({ data }) => {
                        _this.attribute_list = data.attributes;
                    })
                    .catch(({ response }) => {
                        /* eslint-disable */
                        context.commit(SET_ERROR, response.data.errors);
                        /* eslint-enable */
                    });
            });
        },

        getFebrics() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-febrics")
                    .then(({ data }) => {
                        _this.fabric_list = data.febrics;
                    })
                    .catch(({ _response }) => {});
            });
        },
        getStyleCategories() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-styles")
                    .then(({ data }) => {
                        _this.style_category_list = data.styles;
                    })
                    .catch(({ _response }) => {});
            });
        },
        getSleeves() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-sleeves")
                    .then(({ data }) => {
                        _this.sleeve_list = data.sleeves;
                    })
                    .catch(({ _response }) => {});
            });
        },
        clearSubCat() {
            var _this = this;
            var elmnt = document.querySelectorAll(".bg-white-scroll");
            try {
                elmnt.forEach((element) => {
                    element.scrollTop;
                });
            } catch (error) {
                /* noop */
            }
            this.subhover = "";
            let menuSelectedIndex = Object.keys(_this.isHoverTouch).findIndex(
                (element) => _this.isHoverTouch[element]
            );
            if (menuSelectedIndex == -1) {
                this.mega_menus.forEach((menu) => {
                    this.isHoverTouch[`${menu.slug}-0`] = true;
                });
            }
        },
        showSubCat(key) {
            var _this = this;
            this.subhover = "";
            Object.keys(_this.isHoverTouch).forEach((element) => {
                this.$delete(_this.isHoverTouch, element);
            });

            _this.isHoverTouch[key] = true;
        },
        openNav(elementId) {
            document.getElementById(elementId).style.width = "100%";
        },
        oopenNav(elementId) {
            document.getElementById(elementId).style.width = "100%";
        },
        getProductTypeCategories(pagereset = false) {
            var _this = this;
            _this.isBusy = true;

            new Promise(() => {
                if (pagereset) {
                    _this.currentPage = 1;
                    _this.listConfig.offset = 0;
                }
                ApiService.post(
                    "/home-product-type-categories-home",
                    _this.listConfig
                )
                    .then(({ data }) => {
                        _this.category_list = data.categories.rows;
                        _this.isBusy = false;
                    })
                    .catch(({ _response }) => {});
            });
        },
        getCart() {
            var _this = this;
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    ApiService.get("/cart-items-quantity")
                        .then(({ data }) => {
                            _this.cart_total_items = data.total_items;
                        })
                        .catch(({ _response }) => {});
                });
            } else {
                if (localStorage.getItem("cart")) {
                    _this.cart_items = JSON.parse(localStorage.getItem("cart"));
                    _this.cart_total_items = _this.cart_items.length;
                } else {
                    _this.cart_items = [];
                    _this.cart_total_items = 0;
                }
            }
        },
        searchProducts() {
            var _this = this;
            _this.$validator.validateAll("search-form").then((isValid) => {
                if (isValid) {
                    let newKeywordPath =
                        "/search?q=" + _this.filterOptions.searchKeyword;

                    // If Search page
                    if (_this.$route.name == "search") {
                        _this.$bus.emit(
                            "update-search-data",
                            _this.filterOptions
                        );
                        // Update Route Only on same page
                        if (_this.$route.fullPath != newKeywordPath) {
                            _this.$router.push({
                                path: "/search",
                                query: { q: _this.filterOptions.searchKeyword }
                            });
                        }
                    } else {
                        _this.$router.push({
                            path: "/search",
                            query: { q: _this.filterOptions.searchKeyword }
                        });
                    }
                } else {
                    if (_this.$route.name == "search") {
                        _this.$router.push({ name: "home" });
                    } else {
                        /* noop */
                    }
                }
            });
        },
        logout() {
            let _this = this;
            this.$store.dispatch(LOGOUT).then(() => {
                _this.$bus.emit("update-cart");
                localStorage.removeItem("cart");
                this.$router.push({ path: "/" });
            });
        },
        backToAdmin() {
            let _this = this;
            this.$store.dispatch(LOGOUT).then(() => {
                _this.$bus.emit("update-cart");
                localStorage.removeItem("cart");
                window.location.href = this.admin_base_url;
            });
        },
        getMegaMenus() {
            return new Promise(() => {
                ApiService.get("/mega-menus").then(({ data }) => {
                    // Process and sort all levels before assigning to Vue data
                    // Use JSON parse/stringify for deep copy to ensure proper sorting
                    const processedMenus = JSON.parse(
                        JSON.stringify(data.menu_data)
                    ).map((menu) => {
                        // Sort sub-menus (2nd level) - create new array for consistency
                        if (menu.CmsMegaMenus && menu.CmsMegaMenus.length > 0) {
                            menu.CmsMegaMenus = menu.CmsMegaMenus.slice().sort(
                                function (a, b) {
                                    const orderA =
                                        a.order_by != null
                                            ? parseInt(a.order_by)
                                            : 999999;
                                    const orderB =
                                        b.order_by != null
                                            ? parseInt(b.order_by)
                                            : 999999;
                                    return orderA - orderB;
                                }
                            );

                            // Sort nested menus (3rd level) - ensure proper sorting for child items
                            menu.CmsMegaMenus.forEach((sub_menu) => {
                                if (
                                    sub_menu.CmsMegaMenus &&
                                    sub_menu.CmsMegaMenus.length > 0
                                ) {
                                    sub_menu.CmsMegaMenus =
                                        sub_menu.CmsMegaMenus.slice().sort(
                                            function (a, b) {
                                                const orderA =
                                                    a.order_by != null
                                                        ? parseInt(a.order_by)
                                                        : 999999;
                                                const orderB =
                                                    b.order_by != null
                                                        ? parseInt(b.order_by)
                                                        : 999999;
                                                return orderA - orderB;
                                            }
                                        );
                                }
                            });
                        }

                        return menu;
                    });

                    // Sort main menus
                    this.mega_menus = processedMenus.sort(function (a, b) {
                        const orderA =
                            a.order_by != null ? parseInt(a.order_by) : 999999;
                        const orderB =
                            b.order_by != null ? parseInt(b.order_by) : 999999;
                        return orderA - orderB;
                    });

                    // Set hover touch states
                    this.mega_menus.forEach((menu) => {
                        this.isHoverTouch[`${menu.slug}-0`] = true;
                    });
                });
            });
        },
        // get product details and check active menu when we open product details
        getSingleProductData() {
            var _this = this;
            let uri = window.location.href.split("?");
            if (uri[0].match("product-details") == null) {
                _this.productTypeName = "";
            }
            new Promise(() => {
                if (this.$route.params.id_of_product != undefined) {
                    ApiService.get(
                        "/home-single-product/" +
                            this.$route.params.id_of_product
                    )
                        .then(({ data }) => {
                            _this.product = data.product;
                            _this.productTypePath = JSON.parse(
                                _this.product.Category.prod_type_id
                            );
                            if (_this.productTypePath[0] == 1) {
                                _this.productTypeName = "Apparel";
                                _this.productTypePath = "apparel";
                            } else if (_this.productTypePath[0] == 2) {
                                _this.productTypeName = "Bags";
                                _this.productTypePath = "bags";
                            } else if (_this.productTypePath[0] == 3) {
                                _this.productTypeName = "Hats";
                                _this.productTypePath = "hats";
                            } else if (_this.productTypePath[0] == 4) {
                                _this.productTypeName = "Promos";
                                _this.productTypePath = "promos";
                            } else if (_this.productTypePath[0] == 5) {
                                _this.productTypeName = "Specials";
                                _this.productTypePath = "specials";
                            }
                        })
                        .catch(({ _response }) => {});
                }
            });
        },
        isExternalMegaMenuUrl(path) {
            return (
                typeof path === "string" && /^https?:\/\//i.test(path.trim())
            );
        },
        /**
         * Full list page for "Show More" (Brands → /brands; others → CMS url or /product-list/:slug).
         */
        getMegaMenuShowMorePath(mega_menu) {
            if (!mega_menu) return "/";
            if (mega_menu.slug === "brands") {
                return "/brands";
            }
            const u = mega_menu.url;
            if (u && u !== "#" && String(u).trim() !== "") {
                const s = String(u).trim();
                if (this.isExternalMegaMenuUrl(s)) return s;
                return s.startsWith("/") ? s : "/" + s;
            }
            return "/product-list/" + mega_menu.slug;
        },
        megaMenuDropdownOverflows(dropdownEl) {
            if (
                !dropdownEl ||
                typeof dropdownEl.getBoundingClientRect !== "function"
            ) {
                return false;
            }
            const r = dropdownEl.getBoundingClientRect();
            const vw =
                typeof window !== "undefined" ? window.innerWidth : r.width;
            const pad = 16;
            return r.left < pad || r.right > vw - pad;
        },
        /** Viewport-centered Brands mega panel; sets --mega-menu-brands-top for fixed top offset */
        updateBrandsMegaMenuTop() {
            if (typeof document === "undefined") return;
            const header = document.querySelector("header.main-header");
            const fixedMode =
                header && header.classList.contains("fixed-header111");
            /**
             * Use the full menu row box (collapse on desktop), not only ul — the list is often
             * shorter than the padded white bar, which left a visible strip above the panel.
             * Then nudge up to offset panel padding + margin bridge so white content sits ~8px below the bar.
             */
            var anchor = null;
            if (fixedMode) {
                const wrap = document.querySelector(
                    ".navbar_fixed_header_custom"
                );
                if (wrap) {
                    anchor = wrap.querySelector(".navbar.navbar-expand-lg");
                    if (!anchor) {
                        anchor = wrap.querySelector("ul.navbar-nav-menu");
                    }
                }
            } else {
                anchor = document.querySelector(
                    "header.main-header .navbar-collapse.main_top_header"
                );
                if (!anchor) {
                    anchor = document.querySelector(
                        "header.main-header .navbar-collapse.main_top_header ul.navbar-nav-menu"
                    );
                }
            }
            if (!anchor || typeof anchor.getBoundingClientRect !== "function") {
                return;
            }
            var r = anchor.getBoundingClientRect();
            if (r.height < 2 && !fixedMode) {
                const ul = document.querySelector(
                    "header.main-header .navbar-collapse.main_top_header ul.navbar-nav-menu"
                );
                if (ul && typeof ul.getBoundingClientRect === "function") {
                    r = ul.getBoundingClientRect();
                }
            }
            var menuRowBottom = Math.round(r.bottom);
            /* With margin-top -10px and padding-top 22px, inner content starts at top + 12px — set top so gap under bar ≈ 8px */
            var desiredGapPx = 8;
            var innerOffsetFromTopPx = 12;
            var topPx = menuRowBottom + desiredGapPx - innerOffsetFromTopPx;
            document.documentElement.style.setProperty(
                "--mega-menu-brands-top",
                topPx + "px"
            );
        },
        onMegaMenuDesktopMouseEnter(mega_menu, evt) {
            this.cancelMegaMenuBrandsLeaveTimer();
            if (mega_menu.slug === "brands") {
                this.updateBrandsMegaMenuTop();
            }
            this.onMegaMenuDesktopEnter(mega_menu, evt);
        },
        cancelMegaMenuBrandsLeaveTimer() {
            if (this.megaMenuBrandsLeaveTimer != null) {
                clearTimeout(this.megaMenuBrandsLeaveTimer);
                this.megaMenuBrandsLeaveTimer = null;
            }
        },
        scheduleMegaMenuDesktopLeave(mega_menu) {
            if (mega_menu && mega_menu.slug === "brands") {
                this.cancelMegaMenuBrandsLeaveTimer();
                var _this = this;
                this.megaMenuBrandsLeaveTimer = setTimeout(function () {
                    _this.megaMenuBrandsLeaveTimer = null;
                    _this.clearSubCat();
                    _this.onMegaMenuDesktopLeave(mega_menu);
                }, 220);
            } else {
                this.clearSubCat();
                this.onMegaMenuDesktopLeave(mega_menu);
            }
        },
        onMegaMenuDesktopLeave(mega_menu) {
            this.megaMenuOverflowRunId++;
            if (mega_menu && mega_menu.id != null) {
                delete this.megaMenuDisplayLimits[mega_menu.id];
            }
        },
        async onMegaMenuDesktopEnter(mega_menu, evt) {
            /* Brands: fixed 50-item cap + Show More in getMenuColumns — overflow binary search breaks on fixed panel */
            if (mega_menu && mega_menu.slug === "brands") {
                return;
            }
            if (!this.megaMenuShowMoreBreakpointActive) return;
            const all =
                mega_menu && Array.isArray(mega_menu.CmsMegaMenus)
                    ? mega_menu.CmsMegaMenus
                    : [];
            if (!all.length || all.length <= 1) return;

            const runId = ++this.megaMenuOverflowRunId;
            const li = evt && evt.currentTarget;
            if (!li || typeof li.querySelector !== "function") return;

            try {
                await this.$nextTick();
                await new Promise(function (resolve) {
                    requestAnimationFrame(resolve);
                });
                await new Promise(function (resolve) {
                    requestAnimationFrame(resolve);
                });
                if (runId !== this.megaMenuOverflowRunId) return;

                delete this.megaMenuDisplayLimits[mega_menu.id];
                await this.$nextTick();
                await new Promise(function (resolve) {
                    requestAnimationFrame(resolve);
                });
                if (runId !== this.megaMenuOverflowRunId) return;

                const el = li.querySelector(".dropdown-menu");
                if (!el) return;

                var _this = this;
                var overflows = function () {
                    return _this.megaMenuDropdownOverflows(el);
                };

                if (!overflows()) {
                    this.$set(this.megaMenuDisplayLimits, mega_menu.id, null);
                    return;
                }

                const total = all.length;
                var low = 1;
                var high = total;
                var best = 1;

                while (low <= high) {
                    if (runId !== this.megaMenuOverflowRunId) return;
                    var mid = Math.floor((low + high) / 2);
                    this.$set(this.megaMenuDisplayLimits, mega_menu.id, mid);
                    await this.$nextTick();
                    await new Promise(function (resolve) {
                        requestAnimationFrame(resolve);
                    });
                    if (runId !== this.megaMenuOverflowRunId) return;
                    if (!overflows()) {
                        best = mid;
                        low = mid + 1;
                    } else {
                        high = mid - 1;
                    }
                }

                this.$set(this.megaMenuDisplayLimits, mega_menu.id, best);
                await this.$nextTick();
                await new Promise(function (resolve) {
                    requestAnimationFrame(resolve);
                });
                if (runId !== this.megaMenuOverflowRunId) return;
                if (overflows() && best > 1) {
                    this.$set(
                        this.megaMenuDisplayLimits,
                        mega_menu.id,
                        best - 1
                    );
                }
            } catch (err) {
                /* noop */
            }
        },
        shouldShowMegaMenuMore(mega_menu) {
            const all =
                mega_menu && Array.isArray(mega_menu.CmsMegaMenus)
                    ? mega_menu.CmsMegaMenus
                    : [];
            if (mega_menu && mega_menu.slug === "brands") {
                return false;
            }
            if (!this.megaMenuShowMoreBreakpointActive) return false;
            const lim =
                mega_menu && mega_menu.id != null
                    ? this.megaMenuDisplayLimits[mega_menu.id]
                    : undefined;
            return typeof lim === "number" && lim < all.length;
        },
        getMenuColumns(mega_menu) {
            const allMenus =
                mega_menu && Array.isArray(mega_menu.CmsMegaMenus)
                    ? mega_menu.CmsMegaMenus
                    : [];
            if (!allMenus.length) return [];

            if (mega_menu.slug === "brands") {
                const menus = allMenus;
                const chunkSize = 12;
                const columns = [];
                for (let index = 0; index < menus.length; index += chunkSize) {
                    columns.push(
                        menus
                            .slice(index, index + chunkSize)
                            .map((menu, offset) => ({
                                ...menu,
                                _menuIndex: index + offset
                            }))
                    );
                }
                return columns;
            }

            const lim =
                mega_menu && mega_menu.id != null
                    ? this.megaMenuDisplayLimits[mega_menu.id]
                    : undefined;
            const menus =
                typeof lim === "number" && lim < allMenus.length
                    ? allMenus.slice(0, lim)
                    : allMenus;

            const chunkSize = menus.length;
            const columns = [];

            for (let index = 0; index < menus.length; index += chunkSize) {
                columns.push(
                    menus
                        .slice(index, index + chunkSize)
                        .map((menu, offset) => ({
                            ...menu,
                            _menuIndex: index + offset
                        }))
                );
            }

            return columns;
        }
    }
};
</script>
